import { authHeader, httpHelper } from '../helpers';
import { roles } from '../constants';

export const userService = {
    login,
    logout,
    register,
    portalaccess,
    getAll,
    getUserinfoById,
    getUsername,
    getMyInfo,
    getRoles,
    update,
    getMyRole,
    delete: _delete
};

function login(username, password, keepLogon) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`${httpHelper.getApiUrl()}/auth/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // store user details and jwt token in session, local storage to keep user logged in between page refreshes
            sessionStorage.setItem('user', JSON.stringify(user));
            if(keepLogon)
                localStorage.setItem('user', JSON.stringify(user));

            return user;
        });
}

function logout() {
    // remove user from session, local storage to log user out
    sessionStorage.removeItem('user');
    localStorage.removeItem('user');
    localStorage.removeItem('mySiteID');
}

function portalaccess(encStr, keepLogon) {
    const requestOptions = {
        method: 'POST',
        headers: new Headers({
                   'Content-Type': 'application/x-www-form-urlencoded',
          }),
        body: `encStr=${encStr}`
      };

    return fetch(`${httpHelper.getApiUrl()}/auth/portalaccess`, requestOptions)
        .then(handleResponse)
        .then(user => {
            sessionStorage.setItem('user', JSON.stringify(user));
            if(keepLogon)
                localStorage.setItem('user', JSON.stringify(user));    

            return user;
        });
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/users`, requestOptions).then(handleResponse);
}

function getUserinfoById(userID) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/findAdminUserInfo/${userID}`, requestOptions)
    .then(handleResponse)
    .then(user => {
        user.myRole = getMyRole(user.roles);
        return user;
    });
}

function getUsername() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/getUsername`, requestOptions)
    .then(handleResponse);
}


function getMyInfo() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/getMyInfo`, requestOptions)
    .then(handleResponse)
    .then(user => {
        user.myRole = getMyRole(user.roles);
        return user;
    });
}

function getRoles() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/getRoles`, requestOptions)
    .then(handleResponse);
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/register`, requestOptions).then(handleResponse);
}

function update(user) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/users/${user.userID}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(userID) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${httpHelper.getApiUrl()}/adminuser/users/${userID}`, requestOptions).then(handleResponse);
}

function getMyRole(myRoles) {
    const arrRoles = myRoles.split(",");
    let myRole = roles.othersRole;
    if(arrRoles.includes('AA')){
        //개발자
        myRole = roles.developerRole;
    } else if(arrRoles.includes('BA')) {
        //운영자
        myRole = roles.supervisorRole;
    } else if(arrRoles.includes('CA')) {
        //지사운영자
        myRole = roles.administratorRole;
    } else if(arrRoles.includes('DA')) {
        //관리사무소
        myRole = roles.userRole;
    } else {
        //비회원
        myRole = roles.othersRole;
    }

    return myRole;
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                document.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}